export const TriggerTypesToHuman = {
    submitted: 'after form is submitted',
    scheduled: 'after appointment is scheduled',
    rescheduled: 'after appointment is rescheduled',
    canceled: 'after appointment is canceled',
    completed: 'after appointment is completed',
    occurs: 'before appointment occurs',
    created: 'after initial purchase',
    redeemed: 'after this is redeemed',
    expired: 'after expiration',
    expires: 'before expiration or renewal',
    renewed: 'after subscription renewed',
    renewal_failed: 'after subscription payment failed',
    waitlist_signup: 'after someone joins the waitlist',
    spot_available: 'when spot becomes available',
    gift_certificate_delivered: 'when gift certificate is delivered',
    invoice_sent: 'when invoice is sent',
    invoice_paid: 'when invoice is paid',
    invoice_overdue: 'when invoice is overdue',
    payment_recorded: 'when a payment is recorded',
    condition_met: 'after condition is met',
};

export const TriggerOrder = {
    submitted: 0,
    scheduled: 0,
    created: 0,
    waitlist_signup: 0,
    spot_available: 0,
    gift_certificate_delivered: 0,
    invoice_sent: 0,
    payment_recorded: 0,
    condition_met: 0,
    redeemed: 1,
    occurs: 1,
    completed: 2,
    invoice_paid: 2,
    rescheduled: 3,
    expires: 3,
    canceled: 4,
    expired: 4,
    invoice_overdue: 4,
    renewed: 2,
    renewal_failed: 4,
};

export const NegativeOffsetTriggerTypes = ['occurs', 'expires'];
